var map = {
	"./sys-01.png": "m57v",
	"./sys-02.png": "2ZIb",
	"./sys-03.png": "zX5m",
	"./sys-04.png": "KKi6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F0EM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sys ^\.\/sys\-0.*\.png$
// module id = F0EM
// module chunks = 1